<template>
  <button class="frisbuy-guide-button" @click="emit('click')">
    <div class="frisbuy-guide-button__images">
      <span class="frisbuy-guide-button__image-wrapper">
        <img
          class="frisbuy-guide-button__image"
          :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102164/1022_asset_картинки для кнопки с гайдом (1)_1757921809.png')"
          alt=""
          @error="errorImageHandler"
        />
      </span>

      <span class="frisbuy-guide-button__image-wrapper">
        <img
          class="frisbuy-guide-button__image"
          :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102140/1022_asset_картинки для кнопки с гайдом (2)_1757921860.png')"
          alt=""
          @error="errorImageHandler"
        />
      </span>
      <span class="frisbuy-guide-button__image-wrapper">
        <img
          class="frisbuy-guide-button__image"
          :src="getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102158/1022_asset_картинки для кнопки с гайдом (3)_1757921887.png')"
          alt=""
          @error="errorImageHandler"
        />
      </span>
    </div>
    <span class="frisbuy-guide-button__text"> Как попасть в галерею </span>
  </button>
</template>

<script lang="ts" setup>
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

const emit = defineEmits(["click"]);

function getDomainSubstitute(srcUrl: string): string {
  return DomainSubstitute(srcUrl);
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.GALLERY);
}
</script>

<style lang="scss">
.frisbuy-guide-button {
  &, * {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  background: #f6f6f6;

  border: none;
  border-radius: 104px;

  cursor: pointer;
  transition: all 0.2s ease-out;

  padding: 4px 16px 4px 4px;

  &:hover {
    background-color: #ebebeb;
  }

  .frisbuy-guide-button__images {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: 80px;
    height: 32px;

    padding: 0px;

    .frisbuy-guide-button__image-wrapper {
      display: block;
      position: relative;
      width: 32px;
      height: 32px;

      border-radius: 50%;

      overflow: hidden;

      &:not(:first-child) {
        border: 2px solid #f6f6f6;
        margin-left: -20%;
      }

      &:first-child {
        .frisbuy-guide-button__image {
          margin-left: -25%;
        }
      }
    }
  }

  .frisbuy-guide-button__text {
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    color: #212121;
  }
}
</style>
